// extracted by mini-css-extract-plugin
module.exports = {"titleWra":"TitleCom_titleWra__2IIf9"};